import { css } from '@emotion/css';
import classNames from 'classnames';
import { colors } from 'constants/theme';
import { LotterySub, RandomPickOption, RandomPickOptionTypeIn, TypeInputLottery } from 'models/lotteryModel';
import { useEffect, useRef, useState } from 'react';
import { checkValidTypeNum } from '../lotteryFunc';
import LoadingIcon from 'components/loading/LoadingIcon';

let intervalId: any;

interface Props {
    typeInInput: TypeInputLottery;
    onChangeTypeIn: (pickData: TypeInputLottery, amount: number, isValid: boolean) => void;
    subTypeBet: LotterySub;
    onResetBet: () => void;
}
function TypeInLotteryInput(props: Props) {
    const { typeInInput, onChangeTypeIn, subTypeBet, onResetBet } = props;

    const areaInputNumRef = useRef<HTMLTextAreaElement>(null);
    const [selectedRandom, setSelectedRandom] = useState(0);
    const [numInputValue, setNumInputValue] = useState('');
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (typeInInput.layout[0].selectedNums.length === 0) {
            setNumInputValue('');
            setSelectedRandom(0);
        }
    }, [typeInInput]);

    const randomQuickNum = (layout: RandomPickOption) => {
        setSelectedRandom(layout.randomAmount);

        if (layout.key) {
            switch (layout.key) {
                case 'none_1':
                    generateNum({ randomAmount: 1, countNumAsOne: 1, title: layout.key }, { randomFormat: 'xx', separateOperator: ';' });
                    break;
                case 'none_2':
                    generateNum({ randomAmount: 2, countNumAsOne: 1, title: layout.key }, { randomFormat: 'xx', separateOperator: ';' });
                    break;
                case 'none_5':
                    generateNum({ randomAmount: 5, countNumAsOne: 1, title: layout.key }, { randomFormat: 'xx', separateOperator: ';' });
                    break;
                case 'none_10':
                    generateNum({ randomAmount: 10, countNumAsOne: 1, title: layout.key }, { randomFormat: 'xx', separateOperator: ';' });
                    break;
                case 'none_20':
                    generateNum({ randomAmount: 20, countNumAsOne: 1, title: layout.key }, { randomFormat: 'xx', separateOperator: ';' });
                    break;
            }
            return;
        }

        if (layout.value) {
            changeInputNum(layout.value);
            return;
        }
        if (typeInInput?.randomPickLayout?.typeInOptConfig) {
            generateNum(layout, typeInInput.randomPickLayout.typeInOptConfig);
            return;
        }
    };

    const changeInputNum = (value: string) => {
        const { isValid, slNums, amount } = checkValidTypeNum(value, subTypeBet.isXienTruot, subTypeBet.digits);
        const newTypeInInput = {
            ...typeInInput,
            layout: [{ ...typeInInput.layout[0], selectedNums: [slNums] }],
        };
        setNumInputValue(slNums);
        onChangeTypeIn(newTypeInInput, amount, isValid);
    };

    const handleResetBet = () => {
        setNumInputValue('');
        setSelectedRandom(0);
        if (areaInputNumRef.current) {
            areaInputNumRef.current.value = '';
        }
        onResetBet();
    };

    const generateNum = (layout: RandomPickOption, config: RandomPickOptionTypeIn) => {
        setLoading(true);
        const randomWholeNumberLength = config.randomFormat.length;
        let randomResults: string[] = [];
        let randomResultsCheckExisted: string[] = [];
        let randomSingleNums: number[] = [];
        let countAsOneGroupNumbers: string[] = [];

        intervalId = setInterval(() => {
            if (randomResults.length < layout.randomAmount) {
                const singleNum = Math.floor(Math.random() * 9) + 1;
                randomSingleNums.push(singleNum);
                if (randomSingleNums.length === randomWholeNumberLength) {
                    let wholeNumber = randomSingleNums.join('');
                    if (countAsOneGroupNumbers.indexOf(wholeNumber) < 0) {
                        randomSingleNums = [];
                        countAsOneGroupNumbers.push(wholeNumber);
                    } else {
                        randomSingleNums = [];
                    }
                }

                if (countAsOneGroupNumbers.length === layout.countNumAsOne) {
                    let countAsOneGroupNumbersStr = countAsOneGroupNumbers.join();
                    //kiểm tra số random đã tồn tại
                    if (randomResultsCheckExisted.includes(countAsOneGroupNumbersStr)) {
                        countAsOneGroupNumbers = [];
                    } else {
                        randomResultsCheckExisted.push(countAsOneGroupNumbersStr);
                        let finalOne = countAsOneGroupNumbers.join(config.combineAsOneOperator ? config.combineAsOneOperator : '');
                        if (finalOne) {
                            randomResults.push(finalOne);
                            countAsOneGroupNumbers = [];
                        }
                        if (randomResults.length === layout.randomAmount) {
                            changeInputNum(randomResults.join(config.separateOperator));
                        }
                    }
                }
            } else {
                intervalId && clearInterval(intervalId);
                setLoading(false);
            }
        }, 1);
    };

    const openFile = (event: React.ChangeEvent<HTMLInputElement>) => {
        if (event.target.files) {
            const reader = new FileReader();
            const file = event.target.files[0];
            reader.readAsText(file, 'UTF-8');

            reader.onload = (fre: any) => {
                const resultNums = fre.target.result.replace(/\r/g, '').replace(/\n/g, '');
                changeInputNum(resultNums);
                event.target.value = '';
            };
        }
    };

    return (
        <>
            <div className={styles.wrap}>
                <div className={styles.typeinWrap}>
                    <textarea
                        className={styles.typeinArea}
                        rows={8}
                        placeholder={typeInInput.layout[0].title}
                        value={numInputValue}
                        onChange={(e) => changeInputNum(e.target.value)}
                        ref={areaInputNumRef}
                    />

                    <div className="viewAllRandom">
                        <div className={styles.itemRandom}>
                            <div className="titleRandom">
                                <p>Ngẫu nhiên</p>
                            </div>
                            <div className="viewItemRandom">
                                {typeInInput.randomPickLayout?.layout.map((item) => (
                                    <button
                                        type="button"
                                        className={classNames(styles.quickTabItem, { active: item.randomAmount === selectedRandom })}
                                        key={item.randomAmount}
                                        onClick={() => randomQuickNum(item)}
                                    >
                                        {item.title}
                                    </button>
                                ))}
                            </div>
                        </div>

                        <div className={styles.viewButtonBottom}>
                            <div className={styles.btnUploadFile}>
                                <input type="file" autoComplete="off" id="typeInputFile" style={{ display: 'none' }} accept="text/plain" onChange={(e) => openFile(e)} />
                                <label htmlFor="typeInputFile">
                                    <span>+Tải tập tin</span>
                                </label>
                            </div>

                            <button type="button" className={styles.btnDelete} onClick={handleResetBet}>
                                Xoá
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            {loading && <LoadingIcon />}
        </>
    );
}

const styles = {
    wrap: css`
        display: flex;
    `,
    quickTabRandom: css`
        display: flex;
        align-items: center;
        margin-bottom: 16px;
        padding-bottom: 16px;
        border-bottom: 1px solid #bce1e1;
    `,
    quickTabTitle: css`
        padding: 12px;
    `,
    quickTabList: css`
        display: flex;
        align-items: center;
        border-radius: 8px;
        overflow: hidden;
        gap: 12px;
        padding-right: 6px;
    `,
    quickTabItem: css`
        cursor: pointer;
        font-size: 15px;
        background-color: #fecd63;
        width: 70px;
        height: 40px;
        padding-left: 10px;
        padding-right: 10px;
        &.active {
            background: #004d40;
            color: ${colors.white};
        }
    `,
    viewButtonBottom: css`
        display: flex;
        gap: 10px;
    `,
    btnClearRandom: css`
        border: 1px solid ${colors.red};
        padding: 6px 8px;

        border-radius: 8px;
        margin-left: 12px;
        color: ${colors.red};
        cursor: pointer;
        font-size: 14px;
        &:active {
            background: ${colors.red};
            color: ${colors.white};
        }
    `,
    btnUploadFile: css`
        border: 1px solid #c9820a !important;
        border-radius: 3px !important;
        background: linear-gradient(to bottom, #ffffff 0%, #ffc857 2%, #ffad33 100%);
        color: #fff !important;
        cursor: pointer;
        width: 110px;
        label {
            width: 100%;
            height: 100%;
            display: flex;
            align-items: center;
            justify-content: center;
            text-align: center;
            cursor: pointer;
        }
    `,
    btnDelete: css`
        border-radius: 4px !important;
        border: 1px solid #d4d4d4;
        background: linear-gradient(to bottom, #dbdbdb 0%, #dbdbdb 28%, #d1d1d1 65%, #e6e6e6 100%);
        padding-left: 10px;
        padding-right: 10px;
        text-align: center;
        width: 110px;
        padding-top: 8px;
        padding-bottom: 8px;
        font-size: 14px;
        cursor: pointer;
    `,
    btnHelp: css`
        border-radius: 4px !important;
        padding-left: 10px;
        padding-right: 10px;
        text-align: center;
        width: 110px;
        padding-top: 8px;
        padding-bottom: 8px;
        font-size: 14px;
        cursor: pointer;
        color: ${colors.primary};
        font-style: italic;
        font-size: 14px;
        text-decoration: underline;
    `,
    typeinWrap: css`
        display: flex;
        gap: 16px;
        .titleRandom {
            background-color: #004d40;
            color: #fff;
            width: 100px;
            height: 40px;
            text-align: center;
            display: flex;
            align-items: center;
            justify-content: center;
            position: relative;
            margin-right: 20px;
            unicode-bidi: isolate;

            &::after {
                content: '';
                position: absolute;
                right: -15px;
                top: 50%;
                transform: translateY(-50%);
                width: 0;
                height: 0;
                border-style: solid;
                border-width: 20px 0 20px 15px;
                border-color: transparent transparent transparent #004d40;
            }
        }
        .viewAllRandom {
            gap: 10px;
            display: flex;
            flex-direction: column;
        }
    `,
    itemRandom: css`
        display: flex;
        .viewItemRandom {
            display: flex;
            gap: 10px;
        }
    `,
    typeinArea: css`
        border-radius: 4px;
        padding: 8px 8px;
        border-color: transparent;
        resize: none;
        width: 650px;
        height: 150px;
        font-size: 14px;
        &::placeholder {
            color: #90949c;
        }
        &:focus {
            outline: none;
        }
    `,
    typeinAction: css``,
};

export default TypeInLotteryInput;
